module.exports = __webpack_public_path__ + "static/media/kpi.422e9e55.svg";